import React from 'react';
import * as _ from 'lodash';
import { MachineryService } from '../../../services/Machineries';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import { checkSelectedAll } from '../../../utilities/commonUtil';
import { REQUEST_PARAMS } from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';

/**
 * 機材名の複数選択 ドロップダウン
 *
 * @export
 * @class MachineriesDropdown
 * @extends {React.Component}
 */
export class MachineriesDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: sessionStorage.getItem('field_id'),
      loaded: false,
      allLoaded: false,
      opened: false,
      selected: [],
      options: [],
      condition: {
        name: '',
      },
      selectAll: false, // 全選択フラグ
      offset: 0,
      selectedName: '',
      label: this.props.label || '未選択',
      hiddenSelectedOptions: [], // 選択要素保持
    };

    // ユニークID生成
    this.id = _.uniqueId();
    this.targetId = `infinityscroll-target-machinery-multi-dropdown-${this.id}`;
    this.search = this.search.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.setCondition = this.setCondition.bind(this);
    this.handleSelectedRow = this.handleSelectedRow.bind(this);
    this.getMachineries = this.getMachineries.bind(this);
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.handleInview = this.handleInview.bind(this);
    this.resetSelected = this.resetSelected.bind(this);
    this.setValue = this.setValue.bind(this);
    this.searchTimer;
  }

  componentDidMount() {
    this.getMachineries();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.clearFlag) {
      const condition = this.state.condition;
      condition.name = '';
      this.setState({ condition });
      this.search();
    }
    if (_.isEmpty(nextProps.selectedValues) && this.state.selected.length > 0) {
      const state = this.state;
      state.opened = false;
      state.selected = [];
      state.selectAll = false;
      this.setState(state);
    } else if (
      nextProps.selectedValues &&
      nextProps.selectedValues.length > 0
    ) {
      // 初期値が設定されていた場合はselectedへセット
      this.setState({
        selected: nextProps.selectedValues,
        selectedName: nextProps.selectedName || this.props.label,
      });
    }
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(props, state) {
    if (this.state.opened) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (!this.state.opened) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  componentWillUnmount() {
    document.removeEventListener(
      'click',
      this.handleClickOutsideOfComponent,
      false
    );
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.resetSelected();
  };

  handleOpen = event => {
    const state = this.state;
    // 初期化
    if (!this.state.opened) {
      state.selectAll = checkSelectedAll(state.selected, _.map(state.options, 'id'));
      state.opened = true;
      this.setState(state);
    } else {
      this.resetSelected();
    }
    event.preventDefault();
  };

  /**
   * 値を変更前に戻す
   */
  resetSelected() {
    const state = this.state;
    state.opened = false;
    this.setState(state);
  }

  setCondition = e => {
    let condition = this.state.condition;
    condition.name = e.target.value;
    this.setState({ condition });

    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.search();
    }, 1000);
  };

  search = () => {
    let state = this.state;
    state.loaded = false;
    state.allLoaded = false;
    state.offset = 0;
    state.options = [];

    this.setState(state);
    this.getMachineries();
  };

  handleInview() {
    if (this.state.loaded && !this.state.allLoaded) {
      this.setState({
        loaded: false,
      });
      this.getMachineries();
    }
  }

  /**
   * 選択時のイベント
   * @param {string} value // id
   * @param {boolen} checked
   */
  handleSelectedRow = (value, checked) => {
    let selected = _.compact(this.state.selected);
    if (value) {
      if (checked) {
        selected = _.union(selected, [value]);
      } else {
        selected = _.pull(selected, value);
      }
    }
    const state = this.state;
    state.selected = selected;
    state.selectedName = _.join(
      _.map(
        _.filter(this.state.options, op => _.includes(selected, op.id)),
        'name'
      ),
      ','
    );
    state.selectAll = checkSelectedAll(selected, _.map(this.state.options, 'id'));
    state.hiddenSelectedOptions = this.mergeHiddenSelectedOptionsWithSelectedOptions(state.selected);

    this.setState(state, () => {
      this.setValue();
    });
  };

  handleSelectAll() {
    const selectedAll = this.state.selectAll;
    let rows = [];
    if (!selectedAll) {
      rows = _.map(this.state.options, option => option.id);
    }
    const state = this.state;
    state.selectAll = !selectedAll;
    state.selected = rows;
    state.selectedName = _.join(
      _.map(this.state.options, option => option.name),
      ','
    );
    state.hiddenSelectedOptions = this.mergeHiddenSelectedOptionsWithSelectedOptions(state.selected);
    this.setState(state, () => {
      this.setValue();
    });
  }

  setValue = () => {
    // プルダウンの呼び出しコンポーネントでの処理
    if (!_.isUndefined(this.props.foreignKey)) {
      this.props.set(this.props.foreignKey, this.state.selected);
    } else {
      this.props.set('machinery_id', this.state.selected);
    }
  };

  async getMachineries() {
    if (this.state.loaded) {
      return;
    }

    let params = {
      limit: REQUEST_PARAMS.parentLimit,
      offset: _.size(this.state.options),
      name: this.state.condition.name,
      order: 'order_number_asc',
    };

    const doApi = async () => {
      return MachineryService.list(this.state.fieldId, params).then(
        response => {
          if (response.result) {
            let options = this.state.options;
            const data = response.data.entities.machineries;
            const allLoaded = _.size(data) < params.limit;
            const sorted = _.orderBy(
              data,
              ['order_number', 'updated_at'],
              ['asc', 'desc']
            );
            _.each(sorted, datum => {
              let findedRowIndex = _.findIndex(options, option => {
                return option.id === datum.id;
              });
              if (findedRowIndex < 0) {
                options.push(datum);
              }
            });
            const selectAll = checkSelectedAll(this.state.selected, _.map(options, 'id'));
            this.setState({
              options,
              loaded: true,
              allLoaded,
              selectAll,
            });
          }
        }
      );
    };
    await doApi();
  }

  /**
   * 選択要素保持
   */
  mergeHiddenSelectedOptionsWithSelectedOptions = (selectedData) => {
    const selected = selectedData || this.state.selected;

    // 現在dropdownのoptionsより
    const options = _.filter(this.state.options, op =>
      _.includes(selected, op.id)
    );

    // 検索前のdropdownより取得した選択要素より
    _.each(this.state.hiddenSelectedOptions, hiddenOption => {
      if (
        _.filter(options, tempHiddenOption => {
          return (
            tempHiddenOption.id === hiddenOption.id
          );
        }).length === 0 &&
        _.includes(selected, hiddenOption.id)
      ) {
        options.push(hiddenOption);
      }
    });
    return options;
  };

  render() {
    const getName = () => {
      let name = this.state.label;
      if (this.state.selected.length > 0) {
        const options = this.mergeHiddenSelectedOptionsWithSelectedOptions();
        if (options && options.length > 0) {
          name = _.join(_.map(options, 'name'), ',');
        } else {
          name = this.state.selectedName;
        }
      }
      return name;
    };
    return (
      <div className='form-element__element'>
        <div id='form-dropdown' className='dropdown-multi-select' ref={this.parent}>
          <div className='dropdown-multi-select__header'>
            <div
              id='form-dropdown-btn'
              href=''
              className='dropdown-select'
              onClick={this.handleOpen}
            >
              <span className='dropdown-select__txt'>{getName()}</span>
            </div>
          </div>
          <div
            id='form-dropdown-list'
            className={
              this.state.opened
                ? 'dropdown dropdown--dropdown-multi-select show'
                : 'dropdown dropdown--dropdown-multi-select'
            }
          >
            <div className='dropdown__item dropdown__item--wide'>
              <div className='dropdown-multi-select__item'>
                <i className='i-search i-2x' />
                <input
                  type='text'
                  className='SearchDropdown'
                  onChange={this.setCondition}
                  placeholder={messageUtility.getMessage('I-000-090')}
                />
              </div>
              <div className='dropdown-multi-select__item'>
                <div className='dropdown-multi-select__checkall'>
                  <div className='btn-checkbox'>
                    <label htmlFor={`checkall-machinery-${this.id}`}>
                      <input
                        id={`checkall-machinery-${this.id}`}
                        type='checkbox'
                        checked={this.state.selectAll}
                        onChange={this.handleSelectAll}
                      />
                      <i className='i-square-checkbox i-2_5x' />
                    </label>
                  </div>
                  {/* ラベルクリックでラジオボタン選択のため(全選択) */}
                  <label htmlFor={`checkall-machinery-${this.id}`}>
                    {messageUtility.getMessage('I-000-092')}
                  </label>
                </div>
              </div>
              <div className='dropdown-multi-select__scroll' id={this.targetId}>
                <ul id='dropdown-multi-select-list' className='multi-select'>
                  {_.isEmpty(this.state.options) ? (
                    !this.state.loaded ? (
                      <div className='indicator' />
                    ) : (
                      <div className='table-has-no-data'>
                        <div className='table-has-no-data__message'>
                          {messageUtility.getMessage('I-000-046')}
                        </div>
                      </div>
                    )
                  ) : (
                    _.map(this.state.options, (option, index) => (
                      <SelectableOption
                        key={index}
                        option={option}
                        checked={_.includes(
                          this.state.selected,
                          option.id
                        )}
                        targetId={this.id}
                        handleSelectedRow={this.handleSelectedRow}
                      />
                    ))
                  )}
                  {!_.isEmpty(this.state.options) && !this.state.loaded ? (
                    <div className='indicator' />
                  ) : (
                    ''
                  )}
                  {_.isEmpty(this.state.options) ? (
                    ''
                  ) : (
                    <InfinityScrollLoad
                      targetId={this.targetId}
                      total={_.size(this.state.options)}
                      callback={this.handleInview}
                      ignoreIndicator={true}
                    />
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const SelectableOption = ({ option, checked, targetId, handleSelectedRow }) => (
  <li className='multi-select__item'>
    <div className='checkbox'>
      <label htmlFor={`multi-select-machinery-id-${option.id}-${targetId}`}>
        <input
          id={`multi-select-machinery-id-${option.id}-${targetId}`}
          type='checkbox'
          checked={checked}
          onClick={() => handleSelectedRow(option.id, !checked)}
        />
        <i className='i-square-checkbox i-2_5x' />
      </label>
    </div>
    <div
      className='multi-select__label'
      onClick={() => handleSelectedRow(option.id, !checked)}
    >
      {option.name}
    </div>
  </li>
);



// WEBPACK FOOTER //
// ./src/components/dropdowns/multi/Machineries.jsx